import React from 'react';

// Page transitions removed for stability and responsiveness.
// Keep the component API so layouts don't need changes.
const PageTransition = ({ children }) => {
  return (
    <div data-testid="frontdesk-task-region" style={{ width: '100%', flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', overscrollBehaviorY: 'contain', display: 'flex', flexDirection: 'column' }}>
      {children}
    </div>
  );
};

export default PageTransition;
